import {
	InspectionCard,
	InspectionId,
	SurveyDate,
	TaskWrapper,
	ViewDetails,
} from './InspectionProperties.styles';
import {
	ItemWithLabel,
	iso8601DateToLocal,
	useSettings,
} from '@innovyze/stylovyze';
import { InspectionScoredAttributes } from '../../utils';
import React from 'react';
import { useGlobalization } from '@Translations/useGlobalization';
import { extractValue } from '../../utils';

export interface TaskPropertiesProps {
	inspection: InspectionScoredAttributes;
	viewTask?: (inspectionAttributes: InspectionScoredAttributes) => void;
}

export const TaskProperties = ({
	inspection,
	viewTask,
}: TaskPropertiesProps): JSX.Element => {
	const { t } = useGlobalization();
	const { companySettings } = useSettings();

	const onTaskClick = () => {
		if (viewTask) viewTask(inspection);
	};

	return (
		<TaskWrapper data-cy="inspection-properties">
			<InspectionId viewDetails={!!viewTask}>
				{inspection.taskId}
			</InspectionId>
			<SurveyDate viewDetails={!!viewTask}>
				{iso8601DateToLocal(
					extractValue(inspection.completedDate) ?? '',
					companySettings.dateFormat,
				)}
			</SurveyDate>
			{viewTask && (
				<ViewDetails size="small" onClick={onTaskClick}>
					{t('View Details', {
						context: 'Inspection details view further details',
					})}
				</ViewDetails>
			)}
			<InspectionCard>
				<ItemWithLabel
					label={
						t('Task Type', {
							context: 'Inspection properties',
						}) ?? 'Task Type'
					}
					value={inspection.taskTypeName}
				/>
				<ItemWithLabel
					label={
						t('Scheduled Date', {
							context: 'Inspection properties',
						}) ?? 'Scheduled Date'
					}
					value={iso8601DateToLocal(
						extractValue(inspection.scheduledDate) ?? '',
						companySettings.dateFormat,
					)}
				/>
			</InspectionCard>
		</TaskWrapper>
	);
};
